import { Divider, Stack, Text } from '@mantine/core';
import { useQuery } from '@tanstack/react-query';
import Card from 'components/Card';
import DataTables from 'components/DataTables';
import React, { useState } from 'react';
import { reviewMasterPlanService } from 'services/dacum/reviewMasterPlan.service';
import { useReviewMasterplanStore } from 'store/reviewMasterplan';

const KeyActionInformation = () => {
  const [params, setParams] = useState({
    pageSize: 10,
    pageNumber: 1
  });
  const { formData } = useReviewMasterplanStore();
  const competencyId = formData?.competencyId ?? '';
  const shouldFetch = competencyId.trim().length > 0;

  const { data: keyActionData, isPending } = useQuery({
    queryKey: ['reviewMasterPlan', formData, params],
    queryFn: () =>
      reviewMasterPlanService.getKeyActionCompetency({
        pageSize: params.pageSize,
        pageNumber: params.pageNumber,
        competencyId
      }),
    retry: 2,
    enabled: shouldFetch
  });

  return (
    <Card>
      <Stack gap={16}>
        <Stack>
          <Text c={'dark'} fw={700}>
            Key Action Information
          </Text>
          <Divider />
        </Stack>
        <DataTables
          columns={[
            {
              heading: 'Level',
              props: 'level',
              active: true,
              sortable: true,
              disabled: false
            },
            {
              heading: 'Description',
              props: 'description',
              active: true,
              sortable: true,
              disabled: false
            }
          ]}
          loading={isPending}
          data={keyActionData?.data ?? []}
          handleChangePage={(pageNumber) => {
            setParams({
              ...params,
              pageNumber
            });
          }}
          handleChangeSize={(pageSize) => {
            setParams({
              ...params,
              pageSize
            });
          }}
        />
      </Stack>
    </Card>
  );
};

export default KeyActionInformation;
